import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import ProductCardStatic from 'components/consumer/ProductCardStatic';
import classNames from 'classnames';
import { imgixDomain } from 'commons/constants';
import ModularCollectionThumbnail from './ModularCollectionThumbnail';
const ModularProductCard = t0 => {
  const $ = _c(15);
  const {
    product,
    displayType: t1,
    onClick,
    isFixed: t2,
    className: t3,
    overrideLink: t4,
    thumbnail: t5
  } = t0;
  const displayType = t1 === undefined ? "collection" : t1;
  const isFixed = t2 === undefined ? false : t2;
  const className = t3 === undefined ? "" : t3;
  const overrideLink = t4 === undefined ? "" : t4;
  const thumbnail = t5 === undefined ? "" : t5;
  if (!product) {
    return null;
  }
  let t6;
  if ($[0] !== className || $[1] !== displayType || $[2] !== isFixed || $[3] !== onClick || $[4] !== product || $[5] !== thumbnail) {
    t6 = displayType === "collection" ? <button type="button" className={classNames("flex items-center cursor-pointer", {
      [className]: className,
      "flex-col": !isFixed,
      "flex-row mx-2 my-0 [border-bottom:2px_solid_#fff]": isFixed
    })} onClick={onClick}><div className={classNames("flex mx-2 my-0 justify-center [transition:width_.2s_ease-in-out,height_.2s_ease-in-out] w-full", {
        "bg-gray-light9 items-center p-4 min-h-[79px] md:w-[162px] md:h-24": !isFixed,
        "bg-white items-start px-0 py-4 min-w-[36px] min-h-[50px] md:w-auto md:h-[52px]": isFixed
      })}><div className="max-w-[70px]"><ModularCollectionThumbnail image={thumbnail} imageSize={isFixed ? "thumb" : "modular"} isModularSofasPage={true} /></div></div><div className={classNames("font-sans text-base font-bold text-gray-light1 text-center min-h-[23px]", {
        "mx-0 my-2": !isFixed,
        "m-2": isFixed
      })}>{product.collection}</div></button> : null;
    $[0] = className;
    $[1] = displayType;
    $[2] = isFixed;
    $[3] = onClick;
    $[4] = product;
    $[5] = thumbnail;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== className || $[8] !== displayType || $[9] !== overrideLink || $[10] !== product) {
    t7 = displayType === "product" ? <div className={classNames("max-[767px]:flex", {
      [className]: className
    })}><ProductCardStatic layout="mini" name={product.name} variants={product.variants.map(v => ({
        ...v,
        image: `${imgixDomain}${v.image}`,
        path: overrideLink
      }))} variantsToShow={product.variants.map(v_0 => ({
        ...v_0,
        image: `${imgixDomain}${v_0.image}`,
        path: overrideLink
      }))} secondaryImage={`${imgixDomain}${product.secondaryImage}`} productLabel={product.productLabel} path={overrideLink} /></div> : null;
    $[7] = className;
    $[8] = displayType;
    $[9] = overrideLink;
    $[10] = product;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6 || $[13] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};
ModularProductCard.propTypes = {
  product: PropTypes.object.isRequired,
  displayType: PropTypes.oneOf(['product', 'collection']),
  onClick: PropTypes.func,
  isFixed: PropTypes.bool,
  className: PropTypes.string,
  overrideLink: PropTypes.string,
  thumbnail: PropTypes.string
};
export default ModularProductCard;